/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface KsqlCommandV2Response
 */
export interface KsqlCommandV2Response {
    /**
     * 
     * @type {string}
     * @memberof KsqlCommandV2Response
     */
    pipeId: string;
}

export function KsqlCommandV2ResponseFromJSON(json: any): KsqlCommandV2Response {
    return KsqlCommandV2ResponseFromJSONTyped(json, false);
}

export function KsqlCommandV2ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): KsqlCommandV2Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pipeId': json['pipeId'],
    };
}

export function KsqlCommandV2ResponseToJSON(value?: KsqlCommandV2Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pipeId': value.pipeId,
    };
}

